// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: true,

  // base_url: 'http://localhost:3000/admin',
  // image_url: 'http://localhost:3000/',
  // file_url : ' http://localhost:3000/uploads/csv/',
  // socketUrl: 'http://localhost:3000/',

  // base_url: 'https://legacymindedmen.admindd.com/admin',
  // image_url: 'https://legacymindedmen.admindd.com/',
  // socketUrl: 'https://legacymindedmen.admindd.com/',
  // file_url : 'https://legacymindedmen.admindd.com/uploads/csv/',

  base_url: "https://lmm-backend.agiletechnologies.in/admin",
  image_url: "https://lmm-backend.agiletechnologies.in/",
  socketUrl: "https://lmm-backend.agiletechnologies.in/",
  file_url: "https://lmm-backend.agiletechnologies.in/uploads/csv/",
  // base_url: 'http://localhost:7054/admin',
  // image_url: 'http://localhost:7054/',
  // socketUrl: 'http://localhost:7054/',
  // file_url: 'http://localhost:7054/uploads/csv/',
  chatNamespace: "v8/xcode",
  imagePath: "../assets/img/pdfIcon.png",

  // file_url : 'http://34.74.135.14:7054/uploads/csv/',
  // base_url: 'http://34.74.135.14:7054/admin',
  // image_url: 'http://34.74.135.14:7054/',
  // socketUrl: 'http://34.74.135.14:7054/',
};
